module.exports = "/build/web/svg/quote.dc4ea0ea926be5b44244702605bc8fe0.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/quote.svg
// module id = 92
// module chunks = 24